import * as React from "react";
import ReactExport from "react-data-export";
import { IBillingReport } from "@nkr/models/index";
import { ChargeTypes } from "@nkr/enums/index";
import { Button } from "react-bootstrap";

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelSheet;

interface IProps {
    data: {
        items: IBillingReport[]
    }
}

class DownloadReport extends React.Component<IProps, {}> {
    getClaimType = (item: IBillingReport) => {
        let { isSbs, isMedicare, isMedicaid, isGlobal } = item;

        let claimType = "";

        if (isSbs)
            claimType = "SBS";

        if (isMedicare)
            claimType = "Medicare";

        if (isMedicaid)
            claimType = "Medicaid";

        if (isGlobal)
            claimType = "Global"

        if (!isSbs && !isMedicare && !isMedicaid && !isGlobal)
            return "Non-Global";

        return claimType;
    }

    getChargeAmount = (item: IBillingReport, charges: number, chargeType: ChargeTypes) => {
        let { isSbs, isMedicare, isMedicaid, isGlobal, asaUnitPrice, asaUnits } = item;

        if (isSbs) {
            // return charges.toLocaleString('en', { minimumFractionDigits: 2 });
            return charges;
        }

        if (isMedicare) {
            // return "Billed through Medicare using recipient Medicare #";
            return 0;
        }

        if (isMedicaid) {
            if (chargeType == ChargeTypes.PHYSICIAN_CHARGES)
                //return "NKR will remit $2,000";
                return 0;
            else
                // return "NKR will remit $1,000";
                return 0;
        }

        if (isGlobal) {
            if (chargeType == ChargeTypes.PHYSICIAN_CHARGES)
                // return charges.toLocaleString('en', { minimumFractionDigits: 2 });
                return charges;
            else
                // return (asaUnitPrice * asaUnits).toLocaleString('en', { minimumFractionDigits: 2 });
                return asaUnitPrice * asaUnits;
        }

        if (!isSbs && !isMedicare && !isMedicaid && !isGlobal) {
            // return "Bill private insurance directly";
            return 0;
        }
    }

    getClaimAmount = (item: IBillingReport) => {
        const physicianCharges = this.getChargeAmount(item, item.physicianCharges, ChargeTypes.PHYSICIAN_CHARGES);
        const anesthesiaCharges = this.getChargeAmount(item, item.anesthesiaCharges, ChargeTypes.ANESTHESIA_CHARGES);
        const hospitalCharges = item.hospitalCharges;
        const claimAmount = (physicianCharges + anesthesiaCharges + hospitalCharges).toLocaleString('en', { minimumFractionDigits: 2 });

        return claimAmount;
    }

    getStatus = (item: IBillingReport) => {
        switch (item.status) {
            case 10: return "Pending";
            case 15: return "Submitted to Recipient Center";
            case 20: return "Accepted";
            case 30: return "Disputed";
            case 40: return "Invoiced";
            case 50: return "Not Invoiced";
        }
    }

    render = () => {
        const dataSheet1 = [
            {
                columns: [
                    { title: "Donor Center", width: { wpx: 150 } },
                    { title: "Donor Alias", width: { wpx: 150 } },
                    { title: "Donor UNOS ID", width: { wpx: 150 } },
                    { title: "Recipient Center", width: { wpx: 150 } },
                    { title: "Recipient Alias", width: { wpx: 150 } },
                    { title: "Swap #" },
                    { title: "TXP DAte" },
                    { title: "Date Submitted" },
                    { title: "Date Disputed" },
                    { title: "Claim Type" },
                    { title: "Claim Amount" },
                    { title: "Status" }
                ],
                data: this.props.data.items.map(item => {
                    return [
                        { value: item.donorCenterAlias },
                        { value: item.donorAlias },
                        { value: item.donorUnosId },
                        { value: item.recipientCenterAlias },
                        { value: item.recipientAlias },
                        { value: item.chainId + "/" + item.clusterNumber + "/" + item.positionNumber },
                        { value: item.transplantDate },
                        { value: item.dateSubmitted },
                        { value: item.dateRecipientCenterSubmitted },
                        { value: this.getClaimType(item) },
                        { value: this.getClaimAmount(item) },
                        { value: this.getStatus(item) }
                    ];
                })
            }
        ];

        // const dataSheet2 = [
        //     {
        //         columns: [
        //             { title: "Donor Center", width: { wpx: 150 } },
        //             { title: "Donor Surgeon", width: { wpx: 150 } },
        //             { title: "Recipient Center", width: { wpx: 150 } },
        //             { title: "Recipient Surgeon", width: { wpx: 150 } },
        //             { title: "Recipient Issue Type(s)", width: { wpx: 170 } },
        //             { title: "Recipient Center Comments", width: { wpx: 400 } },
        //             { title: "Nephrectomy Date", width: { wpx: 130 } }
        //         ],
        //         data: this.props.data.issues.map(issue => {
        //             return [
        //                 {
        //                     value: issue.donorCenterName,
        //                     style: {
        //                         alignment: {
        //                             vertical: "top"
        //                         }
        //                     }
        //                 },
        //                 {
        //                     value: issue.donorSurgeonName,
        //                     style: {
        //                         alignment: {
        //                             vertical: "top"
        //                         }
        //                     }
        //                 },
        //                 {
        //                     value: issue.recipientCenterName,
        //                     style: {
        //                         alignment: {
        //                             vertical: "top"
        //                         }
        //                     }
        //                 },
        //                 {
        //                     value: issue.recipientSurgeonName,
        //                     style: {
        //                         alignment: {
        //                             vertical: "top"
        //                         }
        //                     }
        //                 },
        //                 {
        //                     value: issue.recipientSwapQualityIssueTypes.join(", "),
        //                     style: {
        //                         alignment: {
        //                             vertical: "top",
        //                             wrapText: true
        //                         }
        //                     }
        //                 },
        //                 {
        //                     value: issue.recipientIssueDescription,
        //                     style: {
        //                         alignment: {
        //                             vertical: "top",
        //                             wrapText: true
        //                         }
        //                     }
        //                 },
        //                 {
        //                     value: issue.nephrectomyDate,
        //                     style: {
        //                         alignment: {
        //                             vertical: "top",
        //                             horizontal: "right"
        //                         }
        //                     }
        //                 }
        //             ]
        //         })
        //     }
        // ]

        return (
            <ReactExport.ExcelFile filename="AutomatedCollectionsClearing.xlsx" element={<Button bsStyle="default">Download Excel File</Button>}>
                <ReactExport.ExcelSheet dataSet={dataSheet1} name="ACC" />
                {/* <ExcelSheet dataSet={dataSheet2} name="Issues by Donor Surgeon" /> */}
            </ReactExport.ExcelFile >
        );
    }
}

export default DownloadReport;